module.exports = __webpack_public_path__ + "img/INE_rocket.772295da.png";